import React from 'react';
import { connect } from 'react-redux';
import { compact, filter, find } from 'lodash';
import moment from 'moment';
import { onClickRowBank } from 'actions/setting/bankAccount';
import { isDirty } from 'redux-form';
import { askConfirmAction } from 'actions/confirm-action';
import { useMokaOutletPropsFirst } from 'utils/formatter';
import styles from './style.css';

class List extends React.Component {
  render() {
    const { outlets, banks, bankAccounts, selectedBankAccount } = this.props;
    const allActiveOutlets = filter(outlets, outlet => {
      const endDate = moment(outlet.end_date);
      const todayDate = moment();
      return endDate.isSameOrAfter(todayDate);
    });
    return (
      <div className={`${styles['table-wrapper-list']}`}>
        <table className={`${styles['table-header']}`}>
          <thead>
            <tr>
              <th>Bank Name</th>
              <th>Account Number</th>
              <th>Account Holder</th>
              <th>Assigned Outlets</th>
            </tr>
          </thead>
        </table>
        <div className={`${styles['table-content-wrapper']}`}>
          <table className={`${styles['table-content']}`}>
            <tbody>
              {bankAccounts.map(bankAccount => {
                const outletList = compact(
                  this._fillOutletProperties(bankAccount.outlets)
                );
                const bank = find(banks, ['id', bankAccount.bank_id]);
                const bankAccountActiveOutlet = this._countBankAccountActiveOutlet(
                  outlets,
                  bankAccount.outlets
                );
                return (
                  <tr
                    key={bankAccount.business_bank_account_id}
                    onClick={() =>
                      this._onClickRow({
                        ...bankAccount,
                        bank_name: bank.name,
                        outlets: outletList,
                      })
                    }
                    className={`${selectedBankAccount !== null &&
                      selectedBankAccount.bankAccId ===
                        bankAccount.business_bank_account_id &&
                      styles['table-row-active']}`}
                  >
                    <td>{bank.name}</td>
                    <td>{bankAccount.account_holder_number}</td>
                    <td>{bankAccount.account_holder_name}</td>
                    <td>
                      {allActiveOutlets.length === bankAccountActiveOutlet
                        ? 'All Outlets'
                        : `${bankAccountActiveOutlet} Outlets`}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  _onClickRow = bankAccount => {
    if (this.props.isDirtyBankAccountForm) {
      this.props.dispatch(askConfirmAction(onClickRowBank(bankAccount)));
    } else {
      this.props.dispatch(onClickRowBank(bankAccount));
    }
  };

  _countBankAccountActiveOutlet = (outlets, bankAccountOutlets) => {
    let totalBankAccountActiveOutlet = 0;
    const outletIds = outlets.map(outlet => {
      return outlet.id;
    });

    bankAccountOutlets.forEach(function(outletId) {
      if (outletIds.includes(outletId)) totalBankAccountActiveOutlet++;
    });
    return totalBankAccountActiveOutlet;
  };

  _fillOutletProperties = outletIds => {
    return outletIds.map(outletId => {
      const outletObj = find(this.props.outlets, ['id', outletId]);
      if (outletObj !== undefined) {
        return {
          id: outletObj.id,
          name: useMokaOutletPropsFirst(outletObj, o => o.name),
        };
      }
    });
  };
}

function mapStateToProps(state) {
  const {
    bankList,
    bankAccountDetail,
    outlets,
    searchBankAccounts,
  } = state.setting.bankAccount;

  return {
    banks: bankList,
    bankAccounts: searchBankAccounts,
    outlets,
    selectedBankAccount: bankAccountDetail,
    isDirtyBankAccountForm: isDirty('bankAccountForm')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List);
